import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Icon,Field,Notify,Form,Toast,Swipe, SwipeItem, List,Loading,PullRefresh,Overlay,Lazyload,Popup,Search,Switch } from 'vant';
import VueClipboards from 'vue-clipboard2'
import VueTouch from 'vue-touch'
import Clipboard from 'v-clipboard'

Vue.use(Clipboard)
Vue.use(Overlay);
Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(VueClipboards);
Vue.use(Lazyload);
Vue.use(Icon);
Vue.use(Field);
Vue.use(Notify);
Vue.use(Form);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
Vue.use(Loading);
Vue.use(PullRefresh);
Vue.use(Popup);
Vue.use(Search);
Vue.use(Switch);
// 全局过滤器
import * as filter from './utils/filter'
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})
Vue.config.productionTip = false
var scrollTopY = 0
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // if(to.name == 'Detail'||to.name == 'Category'){
  //   scrollTopY = window.scrollY
  //   window.scrollTo(0, 0)  
  // }else{
  //   console.log(scrollTopY);

  //   window.scrollTo(0, scrollTopY)
  // }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
